export type Metric = {
	timestamp: number;
	temperature: number;
	humidity: number;
	soilMoisture: number;
};

function randomBetween(min: number, max: number) {
	return Math.random() * (max - min) + min;
}

// Generate 7 days of hourly metrics
const now = Date.now();
const points = 24 * 7;
export const metrics: Metric[] = Array.from({ length: points }).map((_, i) => {
	const t = now - (points - i) * 3600_000;
	return {
		timestamp: t,
		temperature: randomBetween(18, 28),
		humidity: randomBetween(40, 70),
		soilMoisture: Math.round(randomBetween(30, 70))
	};
});


